import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { InsuranceAPIService } from 'src/app/extensions/services/api/insurance-api.service';

@Component({
  selector: 'app-insurance-detail',
  standalone: false,
  templateUrl: './insurance-detail.component.html',
  styleUrl: './insurance-detail.component.scss',
})
export class InsuranceDetailComponent implements OnInit {
  insuranceProps: app.models.DynamicPropsDictionary;
  insuranceSchedulesProps: app.models.DynamicPropsDictionary;
  insuranceId: string;
  insurance: app.models.GetInsuranceModel;
  insurancePaymentSchedules: app.models.GetInsurancePaymentScheduleModel[];

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _router: Router,
    private _insuranceApiService: InsuranceAPIService
  ) {}

  ngOnInit(): void {
    this.insuranceId = this._activatedRoute.snapshot.params['insuranceId'];
    forkJoin({
      insurance: this._insuranceApiService.getInsurance(this.insuranceId),
      insuranceSchedule: this._insuranceApiService.getInsurancePaymentSchedule(this.insuranceId),
    }).subscribe(res => {
      this.insurance = res.insurance.data;
      this.insuranceProps = res.insurance.props;
      this.insurancePaymentSchedules = res.insuranceSchedule.data;
      this.insuranceSchedulesProps = res.insuranceSchedule.props;
    });
  }

  public returnHandler() {
    this._router.navigate(['insurances']);
  }

  public invoiceHandler(invoiceId: string) {
    this._router.navigate(['invoices', invoiceId]);
  }
}
